/**
 * Map route paths to help content keys
 */
export const getHelpKeyForPath = (pathname: string): string => {
    if (pathname === '/dashboard') return 'dashboard';
    if (pathname === '/clients' || pathname.startsWith('/clients')) return 'clients';
    if (pathname.startsWith('/posture-analysis')) return 'postureAnalysis';
    if (pathname.startsWith('/sop-assessment')) return 'sopAssessment';
    if (pathname === '/drills') return 'drillLibrary';
    if (pathname === '/drill-planner') return 'drillPlanner';
    if (pathname === '/chat') return 'askHarry';
    if (pathname === '/progression-model') return 'progressionModel';
    if (pathname === '/coaching') return 'coaching';
    if (pathname === '/settings') return 'settings';
    if (pathname === '/admin/users') return 'adminUsers';
    return 'dashboard'; // fallback
};
